// src/components/Effects/CRTOverlay.js
import React, { useState, useEffect } from 'react';

export default function CRTOverlay({ enabled = true }) {
  const [glitchLine, setGlitchLine] = useState(false);
  const [glitchPos, setGlitchPos] = useState(0);

  useEffect(() => {
    if (!enabled) return;

    // Random horizontal glitch line
    const interval = setInterval(() => {
      if (Math.random() < 0.08) {
        setGlitchPos(Math.random() * 100);
        setGlitchLine(true);
        setTimeout(() => setGlitchLine(false), 50 + Math.random() * 100);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [enabled]);

  if (!enabled) return null;

  return (
    <>
      <div className="crt-overlay" />
      <div className="crt-vignette" />
      {glitchLine && (
        <div
          style={{
            position: 'fixed',
            left: 0,
            top: `${glitchPos}%`,
            width: '100%',
            height: '2px',
            background: 'rgba(255, 255, 255, 0.8)',
            zIndex: 998,
            pointerEvents: 'none',
            boxShadow: '0 0 10px rgba(255, 255, 255, 0.5)',
          }}
        />
      )}
    </>
  );
}